import { Component, OnInit } from '@angular/core';
import { TgUserData } from 'src/app/interfaces/modules/technology/tg-user-data';
import { JsAuthService } from 'src/app/services/apis/java/spring/js-auth/js-auth.service';
import { JsCheckService } from 'src/app/services/apis/java/spring/js-check/js-check.service';
import { BaseurlService } from 'src/app/services/functions/baseurl/baseurl.service';
import { ConsoleService } from 'src/app/services/functions/console/console.service';
import { DomainService } from 'src/app/services/functions/domain/domain.service';
import { ModalService } from 'src/app/services/functions/modal/modal.service';
import { SweetService } from 'src/app/services/functions/sweet/sweet.service';
import { TgUserDataService } from 'src/app/services/modules/technology/tg-user-data/tg-user-data.service';

@Component({
  selector: 'app-te-user-data',
  templateUrl: './te-user-data.component.html',
  styleUrls: ['./te-user-data.component.css']
})
export class TeUserDataComponent implements OnInit {
  domainMajor: string = '';
  urlFront: string = '';

  isLoading: boolean = false;
  pageColumn: string[] = [];
  pageData: any[] = [];
  tgUserData: TgUserData[] = [];

  constructor (
    public jsAuth: JsAuthService,
    public jsCheck: JsCheckService,

    public srvBaseUrl: BaseurlService,
    public srvConsole: ConsoleService,
    public srvDomain: DomainService,
    public srvModal: ModalService,
    public srvSweet: SweetService,

    public srvTgUserData: TgUserDataService,
  ) {}

  async ngOnInit(): Promise<void> {
    this.getDomain();
    this.getUrlHref();

    // await this.moduleLoading('all');
    await this.moduleLoading('page');
  }

  getDomain() {
    let dmMajor = this.srvDomain.getDomainInfo();
    let message = `domain major: ${dmMajor}`
    this.srvConsole.print('info', message);
    this.domainMajor = dmMajor;
  }

  getUrlHref() {
    let urlDomain = this.domainMajor;
    let urlBase = this.srvBaseUrl.getBaseUrl();
    if (urlBase === '/') { urlBase = ''; }
    this.urlFront = urlDomain + urlBase;
    let message = `url front: ${this.urlFront}`
    this.srvConsole.print('info', message);
  }







  async moduleLoading(filter: string) {
    this.srvSweet.process();
    // Registrar el tiempo inicial
    const startTime = performance.now();
    // Enviar la solicitud y esperar la respuesta
    const available = await this.jsCheck.verify();
    // Registrar el tiempo final
    const endTime = performance.now();
    // Calcular el tiempo total de la solicitud
    const elapsedTime = endTime - startTime;

    // Verificar su definicion de respuesta
    if (typeof available !== 'undefined') {
      // Ejecutar operaciones adicionales
      setTimeout(async () => {
        // Cerrar ventana de alerta
        if (available) { this.srvSweet.close(); }

        if (available && filter === 'all') {
          //this.dataAllProcess();
        }
        if (available && filter === 'page') {
          this.dataPageProcess();
        }
      }, elapsedTime + 500);
    }
  }





  dataPageProcess() {
    this.srvTgUserData.jsGetPage().subscribe({
      next: (response: any) => {
        this.dataPageResult(response);
      },
      error: (response: any) => {
        this.dataPageResult(response);
      },
      complete: () => {
        let message = 'request successful';
        this.srvConsole.print('sccs', message);
      },
    });
  }

  dataPageResult(response: any) {
    if (response.status === 403) {
      this.srvSweet.denied();
    }
    if (response.status === 200) {
      this.dataPageField(response);
      this.dataPageLoad(response);
    }
  }

  // Extraer y ordenar columnas
  dataPageField(response: any) {
    let data = response?.body?.content || [];
    const allKeys: Set<string> = new Set();

    // Recopilar claves de los objetos
    data.forEach((item: {}) => {
      this.srvConsole.print('json', item);
      Object.keys(item).forEach(key => {
        allKeys.add(key);
      });
    });

    // Convertir el Set en un array de claves únicas
    let columns = Array.from(allKeys);

    // Definir la función de prioridad
    const priority = (key: string) => {
      if (key === "idRegister") return 1;
      if (key.startsWith("ad")) return 2;
      if (key.startsWith("af")) return 3;
      if (key.startsWith("cd")) return 4;
      return 5;
    };

    // Ordenar las columnas según la prioridad
    columns.sort((a: string, b: string) => {
      return priority(a) - priority(b);
    });

    // Convertir el Set en un array de claves únicas
    this.srvConsole.print('json', columns);
    this.pageColumn = columns;
  }

  dataPageLoad(response: any) {
    // Usar encadenación opcional segun los datos
    const content = response?.body?.content || [];
    // Verificar la existencia de propiedades
    if (content.length > 0) { this.pageData = content; }
    // Imprimir resultados obtenidos de la API
    this.srvConsole.print('json', this.pageData);
  }

  getColumnValue(row: any, column: string): any {
    // Validación de entrada
    if (!row || !column) return null;

    if (column.includes('.')) {
      return column.split('.').reduce(
        (obj, key) => obj && obj[key]
        !== undefined ? obj[key] : null, row
      );
    }

    return row[column] !== undefined ? row[column] : null;
  }

}
